import React from "react";
import "./BannerSlider.css";

const banners = [
  {
    link: "https://px.a8.net/svt/ejp?a8mat=45IF58+AMTQR6+25KS+674EP",
    img: "https://www27.a8.net/svt/bgt?aid=251122220643&wid=001&eno=01&mid=s00000010054001041000&mc=1",
    tracking: "https://www15.a8.net/0.gif?a8mat=45IF58+AMTQR6+25KS+674EP"
  },

  {
    link: "https://px.a8.net/svt/ejp?a8mat=45IF58+5NM9O2+4XOE+5ZU29",
    img: "https://www23.a8.net/svt/bgt?aid=251122220342&wid=001&eno=01&mid=s00000023027001007000&mc=1",
    tracking: "https://www17.a8.net/0.gif?a8mat=45IF58+5NM9O2+4XOE+5ZU29"
  },
  {
    link: "https://px.a8.net/svt/ejp?a8mat=45IF58+CAYIUQ+4RNG+60WN5",
    img: "https://www22.a8.net/svt/bgt?aid=251122220744&wid=001&eno=01&mid=s00000022246001012000&mc=1",
    tracking: "https://www11.a8.net/0.gif?a8mat=45IF58+CAYIUQ+4RNG+60WN5"
  },
    {
    link: "https://px.a8.net/svt/ejp?a8mat=45IF58+CF4K36+4NYY+60WN5",
    img: "https://www21.a8.net/svt/bgt?aid=251122220751&wid=001&eno=01&mid=s00000021769001012000&mc=1",
    tracking: "https://www10.a8.net/0.gif?a8mat=45IF58+CF4K36+4NYY+60WN5",
  },
  /*
    {
    link: "",
    img: "",
    tracking: "",
  }
*/
];

export default function BannerSlider() {
  return (
    <div className="slider-container">
      <div className="slider-track">
        {/** 無限ループさせるため並べる */}
        {[...banners, ...banners, ...banners, ...banners].map((b, index) => (
          <div className="banner-item" key={index}>
            <a href={b.link} rel="nofollow">
              <img src={b.img} width="320" height="100" alt="" />
            </a>
            <img src={b.tracking} width="1" height="1" alt="" />
          </div>
        ))}
      </div>
    </div>
  );
}
